export const ICONS = [
  {
    name: "mail-16",
    path: "/assets/icons/mail-16.svg"
  },
  {
    name: "vector-16",
    path: "/assets/icons/vector-16.svg"
  },
  {
    name: "superuser-16",
    path: "/assets/icons/superuser-16.svg"
  },
  {
    name: "trash-16",
    path: "/assets/icons/trash-16.svg"
  },
  {
    name: "arrow-expander-down-16",
    path: "/assets/icons/arrow-expander-down-16.svg"
  },
  {
    name: "board-server-16",
    path: "/assets/icons/board-server-16.svg"
  },
  {
    name: "sun-16",
    path: "/assets/icons/sun-bright.svg"
  },
  {
    name: "moon-16",
    path: "/assets/icons/moon.svg"
  },
  {
    name: "open-up-16",
    path: "/assets/icons/open-up-16.svg"
  },
  {
    name: "info-16",
    path: "/assets/icons/info-16.svg"
  },
  {
    name: "menu-16",
    path: "/assets/icons/menu-16.svg"
  },
  {
    name: "gear-16",
    path: "/assets/icons/gear-16.svg"
  },
  {
    name: "label-16",
    path: "/assets/icons/label-16.svg"
  },
  {
    name: "sleep-16",
    path: "/assets/icons/sleep-16.svg"
  },
  {
    name: "vector-16",
    path: "/assets/icons/gear-16.svg"
  },
  {
    name: "copy-16",
    path: "/assets/icons/brd_copy-16.svg"
  },
  {
    name: "user-idp-16",
    path: "/assets/icons/user-idp-16.svg"
  },
  {
    name: "reload-16",
    path: "/assets/icons/autorenew-24.svg"
  },
  {
    name: "plus-16",
    path: "/assets/icons/plus-16.svg"
  },
  {
    name: "grid-area-24",
    path: "/assets/icons/grid-area-24.svg"
  },
  {
    name: "grid-column-24",
    path: "/assets/icons/grid-column-24.svg"
  },
  {
    name: "help-16",
    path: "/assets/icons/help-16.svg"
  },
  {
    name: "minus-16",
    path: "/assets/icons/minus-16.svg"
  },
  {
    name: "maximize-16",
    path: "/assets/icons/maximize-16.svg"
  },
  {
    name: "copy-16",
    path: "/assets/icons/copy-16.svg"
  },
  {
    name: "beam-forecasting-16",
    path: "/assets/icons/beam-forecasting-16.svg"
  },
  {
    name: "arrow-left-16",
    path: "/assets/icons/arrow-left-16.svg"
  },
  {
    name: "arrow-right-16",
    path: "/assets/icons/arrow-right-16.svg"
  },
  {
    name: "check-16",
    path: "/assets/icons/check-16.svg"
  },
  {
    name: "edit-16",
    path: "/assets/icons/edit-16.svg"
  },
  {
    name: "filter-16",
    path: "/assets/icons/mage_filter.svg"
  },
  {
    name: "material-link-24",
    path: "/assets/icons/material-link.svg"
  },
  {
    name: "notify-bell-24",
    path: "/assets/icons/notify-bell-24.svg"
  },
  {
    name: "cloud-arrow-up-16",
    path: "/assets/icons/cloud-arrow-up.svg"
  }
];
